import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect } from "react";

import { Card } from "../Card";
import { Button } from "../Button";
import Bg from "../../assets/images/success-bg.png";
import Items from "../../assets/images/success-items.svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const SuccessSubscriptionModal = ({ isOpen, onClose }: Props) => {
  useEffect(() => {
    if (isOpen) {
      const event = localStorage.getItem('last_purchase');
      setTimeout(async () => {
        // @ts-ignore
        gtag('event', 'purchase', {
          'transaction_id': Math.random() * 100000,
          value: event,
          currency: "USD",
          items: [
          {
            item_id: "subscription",
            item_name: "subscription",
          }]
        });
      }, 100);
    }
  }, [isOpen])
  
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={onClose}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className={`
              relative 
            inline-block 
            overflow-hidden 
            transform 
            transition-all s
            align-middle 
            w-[360px]
            `}
            >
              <Card theme="light" size="small" onClose={onClose}>
                <div className="relative text-center">
                  <img className="relative top-[-15px]" src={Bg} alt="background" />
                  <img className="absolute top-[50px] left-[50%] translate-x-[-50%]" src={Items} alt="items" />

                  <p className="text-[31px] leading-xl font-bold mb-[15px]">
                    You are Premium!
                  </p>
                  <p className="text-[15px] px-[10px] mb-[55px]">
                    It is great to hear that you have decided to purchase Premium Tools! You now have access to all brushes and assets. Take your art to the next level!
                  </p>

                  <Button theme="blue" size="medium" onClick={onClose}>
                    Next
                  </Button>
                </div>
              </Card>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export { SuccessSubscriptionModal };
